<div class="calendarContainer">
    <lib-full-view-calendar
        [(currentView)]="currentView"
        [events]="events"
        [eventTemplate]="opportunityCardTemplate"
        (dateRangeSelected)="onDateRangeSelected($event)"
    >
    </lib-full-view-calendar>

    <ng-template #opportunityCardTemplate let-events="events">
        @for (event of events; track event.data?.id || event.title + event.date) {
            @if (event.data) {
                <app-opportunity-card-compact
                    [data]="event.data"
                    [size]="currentView !== 'month' ? 'normal' : 'minimal'"
                ></app-opportunity-card-compact>
            }
        }
    </ng-template>
</div>
